import { almacenAxios } from '@/services/Axios';

const resource = '/v1/inventory';

export default {
  async getSaleProductsInventory(folio) {
    try {
      const response = await almacenAxios.get(`${resource}/sale/products/distribution`, {
        params: { sale_order_folio: folio },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching sale products inventory:', error);
      throw error;
    }
  },
  async saveSaleProductsDistribution(folio, storeId, distributionData, notes) {
    try {
      const body = {
        saleFolio: folio,
        storeId,
        products: distributionData,
        notes,
      };
      const response = await almacenAxios.post(`${resource}/sale/products/distribution`, body);
      return response.data;
    } catch (error) {
      console.error('Error saving sale products distribution:', error);
      throw error;
    }
  },
};
